export default __webpack_public_path__ + "static/media/price-2.7562cf05.png";